<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M2.41,782.5c1.74,0.83,4.38,1.87,6.68,1.87c0,0-0.28,5.16-0.95,7.63c-0.63,2.34-1.4,4.75-2.86,6.68
	c-1.23,1.62-2.86,2.86-4.77,3.82c-1.91-0.96-3.54-2.2-4.77-3.82c-1.47-1.93-2.23-4.34-2.86-6.68c-0.67-2.48-0.95-7.63-0.95-7.63
	c2.3,0,4.94-1.04,6.68-1.87v2.82l1.91,2.86l-4.77,2.86l5.73,3.82l-3.82,2.86l2.86,2.86l-0.95-2.86l4.77-2.86l-4.77-3.82l5.73-2.86
	l-2.86-2.86V782.5z"/>
</svg>

</template>